import { render, staticRenderFns } from "./RecaptchaV2.vue?vue&type=template&id=92051b40&"
import script from "./RecaptchaV2.vue?vue&type=script&lang=ts&"
export * from "./RecaptchaV2.vue?vue&type=script&lang=ts&"
import style0 from "./RecaptchaV2.vue?vue&type=style&index=0&id=92051b40&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports